module.exports = __webpack_public_path__ + "static/media/DianaC-CV.ef78ff0a.pdf";